import { useEffect, useRef, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import Celebration from '@/assets/images/svg/celebration.svg';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { useLessons } from '@/packages/eduplay/context/lessons';
import { useGenerateCertificate } from '@/packages/eduplay/hooks';

export const CompletedCourseDialog = () => {
  const { courseName, isCompleted, courseId } = useLessons();
  const { viewCertificate, loadingCertificate } = useGenerateCertificate(
    courseId!
  );

  const navigate = useNavigate();
  const previousIsCompletedRef = useRef<boolean | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
    previousIsCompletedRef.current = null;
  }, [courseId]);

  useEffect(() => {
    if (typeof isCompleted !== 'boolean') return;

    if (previousIsCompletedRef.current === null) {
      previousIsCompletedRef.current = isCompleted;
      return;
    }

    if (!previousIsCompletedRef.current && isCompleted) {
      setOpen(true);
    }

    previousIsCompletedRef.current = isCompleted;
  }, [isCompleted]);

  const handleClose = () => {
    setOpen(false);
    navigate('/meu-aprendizado');
  };

  return (
    <ConfirmDialog
      onClose={handleClose}
      onConfirm={viewCertificate}
      open={open}
      disableConfirmButton={loadingCertificate}
      actionLabels={{
        confirm: loadingCertificate
          ? 'Gerando certificado...'
          : 'Acessar certificado',
        cancel: 'Fechar',
      }}
    >
      <Box component="img" src={Celebration} sx={{ height: 60, width: 60 }} />
      <Stack gap={1} mt={3}>
        <Typography variant="h2">Curso concluído com sucesso!</Typography>
        <Typography>
          Você concluiu o curso {courseName}. Acesse seu certificado e celebre
          compartilhando sua nova conquista!
        </Typography>
      </Stack>
    </ConfirmDialog>
  );
};
